
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/[articleSlug]",
      function () {
        return require("private-next-pages/help/[articleSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/[articleSlug]"])
      });
    }
  